import {StatusPageLayout} from "@/StatusPageLayout.tsx";
import {HostStatusPage} from "@/pages/statuspages/consumption/HostStatusPage.tsx";
import StatusPageConsumption from "@/pages/statuspages/consumption/StatusPageConsumption.tsx";
import {CheckDrilldown} from "@/pages/statuspages/consumption/pages/CheckDrilldown.tsx";
import {HostCheckDrilldown} from "@/pages/statuspages/consumption/pages/HostCheckDrilldown.tsx";
import {createBrowserRouter, RouteObject} from "react-router";
import {PrivateStatusPageLayout} from "./PrivateStatusPageLayout.tsx";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <StatusPageLayout />,
    children: [
      {
        index: true,
        element: <HostStatusPage />,
      },
      {
        // Host-mode (custom-domain) drilldown: slug is resolved from the host, not the
        // path. "c" is below the 3-char minimum slug length, so it can't collide with a
        // real ":slug/:serviceId" page.
        path: "c/:serviceId",
        element: <HostCheckDrilldown />,
      },
      {
        path: ":slug",
        element: <StatusPageConsumption />,
      },
      {
        path: ":slug/:serviceId",
        element: <CheckDrilldown />,
      },
    ],
  },
  {
    path: "/private",
    element: <StatusPageLayout />,
    children: [
      {
        element: <PrivateStatusPageLayout />,
        children: [
          {
            path: ":id",
            element: <StatusPageConsumption mode="private" />,
          },
          {
            path: ":id/:serviceId",
            element: <CheckDrilldown mode="private" />,
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default router;
